var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Linked Transaction No.",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "800px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pb20"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.relatedApplymentyList,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "applymentNo",
      "align": "center",
      "label": "Linked Transaction No.",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "align": "center",
      "label": "Update Time"
    }
  })], 1)], 1), _c('div', {
    staticClass: "pb20"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.relatedQuotationList,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "applymentNo",
      "align": "center",
      "label": "Linked Quotation No.",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "align": "center",
      "label": "Update Time"
    }
  })], 1)], 1), _c('div', {
    staticClass: "pb20"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.relatedAdjustmentList,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adjustmentNo",
      "align": "center",
      "label": "Linked Quotation (V)",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "align": "center",
      "label": "Update Time"
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }